import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { period: { type: Number, default: 6 } }

  connect() {
    this.applyFilter()
    this.updateButtons()
  }

  select(event) {
    this.periodValue = parseInt(event.currentTarget.dataset.period)
  }

  periodValueChanged() {
    this.applyFilter()
    this.updateButtons()
  }

  applyFilter() {
    const summaryRows = this.element.querySelectorAll('[data-row-type="summary"]')
    if (summaryRows.length === 0) return

    const maxIndex = Math.max(...Array.from(summaryRows).map(r => parseInt(r.dataset.monthIndex)))
    const cutoff = maxIndex - this.periodValue + 1

    this.element.querySelectorAll("[data-month-index]").forEach((row) => {
      const index = parseInt(row.dataset.monthIndex)
      if (row.dataset.rowType === "summary") {
        row.classList.toggle("hidden", index < cutoff)
      } else {
        if (index < cutoff) row.classList.add("hidden")
      }
    })
  }

  updateButtons() {
    this.buttonTargets.forEach((button) => {
      const active = parseInt(button.dataset.period) === this.periodValue
      button.classList.toggle("bg-emerald-700", active)
      button.classList.toggle("text-white", active)
      button.classList.toggle("bg-gray-800", !active)
      button.classList.toggle("text-gray-400", !active)
    })
  }
}
